/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
export const shouldUpdateScroll = () => {
  return false;
};
// You can delete this file if you're not using it
